import React, { useState } from "react";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import { Logo }  from "../_components/Imagepath";
import axios from "../api/axios";
import {  Apitoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const CustomerForgotPassword = () => {
  const [backendErrors, setBackendErrors] = useState("");
  const [backendSuccess, setBackendSuccess] = useState(false);

  // const ForgotSchema = Yup.object().shape({
  //   email: Yup.string()
  //     .email("Email is not valid")
  //     .required("Please enter your email."),
  // });

  const {
    values,
    errors,
    // touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      user_email: "",
    },
    //validationSchema: ForgotSchema,

    onSubmit: (values, actions) => {
      axios
        .post("/customerportal/forgot-password", values, {
          headers: {
            Apitoken: Apitoken,
          },
        })
        .then((response) => {
          //let data = response.data;
        //  let errors = data.error;
          actions.setSubmitting(false);
          setBackendSuccess('');
          delete backendErrors['error'];
          if (response.data.code === 200) {
            setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            actions.resetForm();
          }
          else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
        }
        else if (response.data.code === 401) {
          setBackendErrors(response.data.error);
        }
        else {
           setBackendErrors(response.data.error);
        }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const isLoggedInVAr =  localStorage.getItem("auth_id");
  console.log(isLoggedInVAr);

//if(isLoggedIn == true){
//  setSaleAnalyticsBar(isLoggedIn);
//}
  if(isLoggedInVAr > 0){
    console.log("IF here")
    window.location.href = "/customerportal/profile";

  }else{

    console.log("login here");
    setTimeout(() => {
     //window.location.href = "/login";
      }, 1000);
  }

  return (
    <div className="main-wrapper login-body">
      <div className="login-wrapper">
        <div className="container">
          <ToastContainer />
          <img className="img-fluid logo-dark mb-2" src={Logo} alt="Logo" />
          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>Forgot Password?</h1>
                <p className="account-subtitle">
                  Enter your email to get a password reset link
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-control-label">Email Address</label>
                    <input
                      id="email"
                      type="email"
                      name="user_email"
                      className={
                        errors.email
                          ? "form-input form-control input-error"
                          : "form-input form-control"
                      }
                      placeholder="Email"
                      value={values.user_email}
                      onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} onBlur={handleBlur}
                    />
                    <small>
                    {backendErrors.user_email  && (
                        <span className="form-error mt-1">
                        {backendErrors.user_email}
                      </span>
                    )}
                      {backendErrors.error  && (
                            <span className="form-error mt-1">
                              {backendErrors.error}
                            </span>  )}
                      {/* {backendErrors && (
                        <span className="form-error mt-1">{backendErrors}</span>
                      )}
                   */}
                       {backendSuccess && (
                        <span className="from-success mt-1">
                          {backendSuccess}
                        </span> )}  
                    </small>
                  </div>
                  <div className="form-group mb-0">
                    <button
                      disabled={isSubmitting}
                      className="btn btn-lg btn-block w-100 btn-primary w-100"
                      type="submit" id="form-submit"
                    >
                      Reset Password
                    </button>
                  </div>
                </form>
                <div className="text-center dont-have">
                  Remember your password? <Link to="/customerportal/login">Login</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerForgotPassword;
